
/* ============================================================
 * Magie du curseur sur TOUT le site
 * - halo de lune bleute qui suit la souris (rendu additif :
 *   il ne se revele que sur les fonds sombres, comme une vraie lueur)
 * - trainee de poussiere d'etoiles doree, avec une pointe d'ambre
 *   en fondu normal pour rester visible sur les sections claires
 * La boucle s'endort toute seule (souris immobile + particules eteintes),
 * coupee sur tactile et si l'utilisateur reduit les animations.
 * ============================================================ */
(function(){
  if(!window.requestAnimationFrame) return;
  if(matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  if(matchMedia('(hover: none)').matches) return;
  var cv=document.createElement('canvas');
  cv.style.cssText='position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2000;';
  cv.setAttribute('aria-hidden','true');
  document.body.appendChild(cv);
  var ctx=cv.getContext('2d');
  var W=0,H=0;
  function resize(){
    var dpr=Math.min(devicePixelRatio||1,2);
    W=innerWidth;H=innerHeight;
    cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  addEventListener('resize',resize,{passive:true});
  resize();
  function dot(r,g,b){
    var c=document.createElement('canvas');c.width=c.height=64;
    var x=c.getContext('2d');
    var gr=x.createRadialGradient(32,32,0,32,32,32);
    gr.addColorStop(0,'rgba(255,255,255,1)');
    gr.addColorStop(.22,'rgba('+r+','+g+','+b+',.9)');
    gr.addColorStop(.55,'rgba('+r+','+g+','+b+',.22)');
    gr.addColorStop(1,'rgba('+r+','+g+','+b+',0)');
    x.fillStyle=gr;x.fillRect(0,0,64,64);
    return c;
  }
  var GOLD=dot(255,214,140),BLUE=dot(170,200,255),AMBER=dot(188,132,52);
  var parts=[],mx=-1,my=-1,tx=-1,ty=-1,moved=0,lastMove=0;
  var running=false,raf=0,last=0;
  function loop(ms){
    if(!running) return;
    raf=requestAnimationFrame(loop);
    if(ms-last<24) return;
    var dt=Math.min(ms-last,80); last=ms;
    ctx.clearRect(0,0,W,H);
    if(tx<0 && !parts.length && ms-lastMove>2500){ running=false; cancelAnimationFrame(raf); return; }
    if(tx>=0){
      mx+=(tx-mx)*.09; my+=(ty-my)*.09;
      ctx.globalCompositeOperation='lighter';
      var g=ctx.createRadialGradient(mx,my,0,mx,my,210);
      g.addColorStop(0,'rgba(140,175,255,.11)');
      g.addColorStop(.5,'rgba(140,175,255,.04)');
      g.addColorStop(1,'rgba(140,175,255,0)');
      ctx.globalAlpha=1;ctx.fillStyle=g;
      ctx.beginPath();ctx.arc(mx,my,210,0,6.3);ctx.fill();
    }
    for(var k=parts.length-1;k>=0;k--){
      var p=parts[k];
      p.x+=p.vx*dt; p.y+=p.vy*dt; p.life-=p.dec*dt;
      if(p.life<=0){ parts.splice(k,1); continue; }
      var a=Math.max(0,Math.min(1,p.life)), sz=p.s*(.4+.6*p.life);
      ctx.globalCompositeOperation='lighter';
      ctx.globalAlpha=a*.9;
      ctx.drawImage(p.g?GOLD:BLUE,p.x-sz,p.y-sz,sz*2,sz*2);
      ctx.globalCompositeOperation='source-over';
      ctx.globalAlpha=a*.2;
      ctx.drawImage(AMBER,p.x-sz,p.y-sz,sz*2,sz*2);
    }
    ctx.globalAlpha=1;ctx.globalCompositeOperation='source-over';
  }
  function start(){ if(running) return; running=true; last=performance.now(); raf=requestAnimationFrame(loop); }
  addEventListener('mousemove',function(e){
    tx=e.clientX; ty=e.clientY;
    if(mx<0){mx=tx;my=ty;}
    lastMove=performance.now();
    moved+=Math.abs(e.movementX||0)+Math.abs(e.movementY||0);
    if(moved>34){
      moved=0;
      if(parts.length>80) parts.shift();
      parts.push({x:tx+(Math.random()-.5)*14,y:ty+(Math.random()-.5)*10,
        vx:(Math.random()-.5)*.03,vy:-.015-Math.random()*.03,
        life:1,dec:.0011+Math.random()*.0009,s:3+Math.random()*4.5,g:Math.random()<.82});
    }
    start();
  },{passive:true});
  document.addEventListener('mouseleave',function(){ tx=-1; ty=-1; });
  document.addEventListener('visibilitychange',function(){ if(document.hidden){ running=false; cancelAnimationFrame(raf); } });
})();
